import React from "react";

const LoaderComp = () => {
  return (
    <div className="w-full h-[250px] flex items-center justify-center">
      <div className="text-center w-[200px] mx-auto">
        <img src="/images/ohhto-loading.gif" alt="loader" className="w-[100%] h-auto"/>
      </div>
    </div>
  )
};

export default LoaderComp;
